<template>
    <div class="services-area">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <div class="card mb-4 services-card">
                        <div class="card-body">
                            <i class='bx bx-wifi'></i>
                            <h5 class="card-title">Joxi Services</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae qui.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="card mb-4 services-card color-style-5c31d6">
                        <div class="card-body">
                            <i class='bx bx-time' ></i>
                            <h5 class="card-title">Trace Your Time</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae qui.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="card mb-4 services-card">
                        <div class="card-body">
                            <i class='bx bxs-business' ></i>
                            <h5 class="card-title">Business FrameWork</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae qui.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <div class="card mb-4 services-card color-style-5c31d6">
                        <div class="card-body">
                            <i class='bx bx-share-alt' ></i>
                            <h5 class="card-title">Shares Business</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae qui.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                    <div class="card mb-4 services-card">
                        <div class="card-body">
                            <i class='bx bx-wifi'></i>
                            <h5 class="card-title">Joxi Services</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                    <div class="card mb-4 services-card color-style-5c31d6">
                        <div class="card-body">
                            <i class='bx bx-time' ></i>
                            <h5 class="card-title">Trace Your Time</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6">
                    <div class="card mb-4 services-card">
                        <div class="card-body">
                            <i class='bx bxs-business' ></i>
                            <h5 class="card-title">Business FrameWork</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-sm-6">
                    <div class="card mb-4 services-card color-style-5c31d6">
                        <div class="card-body">
                            <i class='bx bx-time' ></i>
                            <h5 class="card-title">Trace Your Time</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-sm-6">
                    <div class="card mb-4 services-card">
                        <div class="card-body">
                            <i class='bx bxs-business' ></i>
                            <h5 class="card-title">Business FrameWork</h5>
                            <p class="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis temporibus nihil perspiciatis nobis explicabo eum iure dolor labore quod veniam enim repellat id consectetur, doloribus recusandae.</p>
                            <a href="#" class="btn btn-primary">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServicesContent'
}
</script>

<style lang="scss">
.services-card {
	border: none;
	box-shadow: var(--box-shadow);
	.card-body {
		padding: 30px;
		i {
			display: inline-block;
			width: 60px;
			height: 60px;
			line-height: 60px;
			text-align: center;
			background-color: #28C76F;
			color: var(--white-color);
			font-size: 25px;
			border-radius: var(--border-radius);
			margin-bottom: 20px;
		}
		h3 {
			margin-bottom: 20px;
		}
		p {
			margin-bottom: 20px;
		}
		.btn {
			background-color: var(--main-color);
		}
	}
	&.color-style-5c31d6 {
		i {
			background-color: #5c31d6;
		}
		.btn {
			background-color: #5c31d6;
		}
	}
}
</style>